export const STATUS = {
  sospeso: { label: "In sospeso", short: "SOSPESO", sub: "da ordinare al fornitore", dot: "bg-[#DC2626]", chip: "bg-[#FEE2E2] text-[#991B1B]", bar: "border-[#DC2626]", text: "text-[#DC2626]" },
  lavorazione: { label: "In lavorazione", short: "IN CORSO", sub: "ordinato, da consegnare", dot: "bg-[#EA580C]", chip: "bg-[#FFEDD5] text-[#9A3412]", bar: "border-[#EA580C]", text: "text-[#C2410C]" },
  completato: { label: "Completati", short: "RITIRATO", sub: "ritirato dal cliente", dot: "bg-[#16A34A]", chip: "bg-[#DCFCE7] text-[#166534]", bar: "border-[#16A34A]", text: "text-[#15803D]" },
};
export const STATUS_KEYS = Object.keys(STATUS);
export const MONTHS = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
export const WEEKDAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

const pad = (n) => String(n).padStart(2, "0");
export const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const todayIso = () => iso(new Date());
export const itDate = (s) => (s ? s.split("-").reverse().join("/") : "");
export const longDate = (s) => new Date(`${s}T12:00:00`).toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" });
export const daysSince = (s) => Math.round((new Date(`${todayIso()}T12:00:00`) - new Date(`${s}T12:00:00`)) / 86400000);
export const daysText = (n) => (n <= 0 ? "oggi" : n === 1 ? "1 giorno" : `${n} giorni`);

export function waNumber(phone) {
  let d = (phone || "").replace(/[^\d+]/g, "");
  if (d.startsWith("+")) d = d.slice(1);
  else if (d.startsWith("00")) d = d.slice(2);
  else if (!(d.startsWith("39") && d.length >= 11)) d = `39${d}`;
  return d.replace(/\D/g, "");
}

export const fillMsg = (msg, o) => (msg || "").replaceAll("{nome}", o.name || "").replaceAll("{articolo}", o.item || "");
export const waLink = (phone, text) => `https://wa.me/${phone ? waNumber(phone) : ""}?text=${encodeURIComponent(text)}`;

export function monthGrid(year, month) {
  const first = new Date(year, month, 1);
  const start = new Date(year, month, 1 - ((first.getDay() + 6) % 7));
  return Array.from({ length: 42 }, (_, i) => new Date(start.getFullYear(), start.getMonth(), start.getDate() + i));
}
